module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Pamela Eisenbaum\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_c('P', [_vm._v("Pamela Eisenbaum is the associate professor of biblical studies and Christian origins at Iliff School of Theology in Denver, Colorado. Eisenbaum is a national media expert on early Christianity and, as a practicing Jew teaching in a Christian seminary, has a unique perspective on the origins of Christianity.")])], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dgigVb/tc-custom/9780061990205.jpg?1718106104314",
      "alt": "This image is the cover for the book Paul Was Not a Christian"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Paul Was Not a Christian\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Pamela Eisenbaum, an expert on early Christianity, reveals the true nature of the historical Paul in "), _c('i', [_vm._v("Paul Was Not a Christian. ")]), _vm._v("She explores the idea of Paul not as the founder of a new Christian religion, but as a devout Jew who believed Jesus was the Christ who would unite Jews and Gentiles and fulfill God’s universal plan for humanity. Eisenbaum’s work in "), _c('i', [_vm._v("Paul Was Not a Christian ")]), _vm._v(" will have a profound impact on the way many Christians approach evangelism and how to better follow Jesus’s—and Paul’s—teachings on how to live faithfully today."), _c('b', [_c('i')])]), _c('p'), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    HarperCollins\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0